import React from 'react';
import SetPasswordPage from './SetPasswordPage';

export default function ResetPasswordPage() {
  return (
    <SetPasswordPage
      title="Choose a new password"
      subtitle="Set a new password for your account."
      cta="Update password"
    />
  );
}
